/**
 * @param {number} n
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export default function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}
